import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "heading-small text-muted mb-4" }, "Part Supplied", -1)
const _hoisted_3 = { class: "col-lg-2 col-md-8" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-control-label" }, "Part Number", -1)
const _hoisted_6 = { class: "col-lg-2 col-md-4" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-control-label" }, "Qty", -1)
const _hoisted_9 = { class: "col-lg-4" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-control-label" }, "Description", -1)
const _hoisted_12 = { class: "col-lg-3" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-control-label" }, "Remarks", -1)
const _hoisted_15 = {
  key: 0,
  class: "col-12 mb-5"
}
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_input_number = _resolveComponent("n-input-number")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_n_input, {
                value: _ctx.modelValue[index].part_number,
                "onUpdate:value": ($event: any) => ((_ctx.modelValue[index].part_number) = $event),
                disabled: _ctx.viewOnly,
                type: "text",
                size: "large",
                placeholder: "Part Number"
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_n_input_number, {
                value: _ctx.modelValue[index].quantity,
                "onUpdate:value": ($event: any) => ((_ctx.modelValue[index].quantity) = $event),
                disabled: _ctx.viewOnly,
                size: "large",
                min: "1",
                placeholder: "1"
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_n_input, {
                value: _ctx.modelValue[index].description,
                "onUpdate:value": ($event: any) => ((_ctx.modelValue[index].description) = $event),
                disabled: _ctx.viewOnly,
                type: "text",
                size: "large",
                placeholder: "Description"
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_n_input, {
                value: _ctx.modelValue[index].remarks,
                "onUpdate:value": ($event: any) => ((_ctx.modelValue[index].remarks) = $event),
                disabled: _ctx.viewOnly,
                type: "text",
                size: "large",
                placeholder: "Remarks"
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ])
          ]),
          (!_ctx.viewOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_n_button, {
                    class: "flex-fill",
                    type: "error",
                    dashed: "",
                    onClick: ($event: any) => (_ctx.removeRow(index, $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" - Remove ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (!_ctx.viewOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_n_button, {
              class: "flex-fill",
              type: "primary",
              dashed: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addRow($event)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" + Add Part ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}